import React from "react";
import CellInput from "../../global/CellInput";
import { translateLabel } from "../../../services/functions";


const moment = require("moment");
const generatePaymentsReceiptColumns = (
    {
        t,
        i18n,
        handleThermalPrint
    }
        = {}) => {
    // let columns = queueColumns != null ? queueColumns.split(",") : null;


  const profileIdOptions = profileIdOptions?.map((profId) => ({ ...profId, label: t([profId.label]) }))


    const currencyOptions = [
        { value: "ALL", label: "Lek" },
        { value: "EUR", label: "Euro"},
        { value: "USD", label: "USD" },
    ];

    const statusOptions = [
    
        {
            label: (t("bkt.receivedStatus")),
            value:"RECEIVED"
        },
        {
            label: (t("bkt.reportedStatus")),
            value:"REPORTED"
        },
      
    ]

    return [
   
        {
            header: t(["home.status"]),
            field: "status",
            style: { minWidth: "220px", maxWidth: "220px" },
            filter: true,
            persisted: true,
            filterType: "DROPDOWN",
            filterConfig: {
                options: statusOptions,
                optionValue: "value",
                optionLabel: "label",
            },
        },

//         {
//             header: t(["invoice.print"]),
//             field: 'print',
//             style: { minWidth: "150px", maxWidth: "300px" },
//             body: invoice => (
//                 <div className='d-flex align-items-center'>

//                     {invoice.iic &&
//                         <a
//                             href="#"
//                             className={"nav-link p-0 d-flex-align-items-center "}
//                             onClick={(e) => { e.preventDefault(); handleThermalPrint(invoice.id) }}>
//                             <img src="https://profisc.al/wp-content/uploads/2021/10/kupon.svg" title={t('invoice.printThermal')}  width="38" height="32" className="mr-1" />
//                         </a>}

// {/* */}

//                 </div>
//             ),
//             persisted:true
//         },
       
        {
            header: "Derguesi/Bleresi",
            field: "buyerName",
            style: { minWidth: "220px", maxWidth: "300px" },
            filter: true,
            persisted: true,
            default:true,
        },

        {
            header: t(["table.buyerNIPT"]),
            field: "buyerNipt",
            style: { minWidth: "150px", maxWidth: "300px" },
            filter: true,
            persisted: true,
            default:true,
        },

        {
            header: t(["invoice.DocNumber"]),
            filter: true,
            field: "ublId",
            style: { minWidth: "180px", maxWidth: "300px" },
            persisted: true,
            default: true
        },

        {
            header: t("invoice.IIC"),
            field: "iic",
            filter: true,
            style: { minWidth: "250px", maxWidth: "200px" },
            body: (receipt) => <CellInput value={receipt?.iic ?? ""} width={220} onFocus={(event) => event.target.select()} />,
        },

        {
            field: "issueDate",
            header: t(["table.issueDatetime"]),
            body: (receipt) =>receipt?.issueDate ? moment(receipt?.issueDate).format("DD/MM/YYYY HH:mm"):"",
            style: { minWidth: 200, maxWidth: 300 },
            filter: true,
            filterType: "DATE",
            filterConfig: {
                like: false,
                
            },
            persisted: true,
            formattedExportValue: true,
            preventExcelFormat: true,
            sortable: true,

        },

  {
            field: "dueDate",
            header: t(("invoice.paymentDate")),
            body: (receipt) =>receipt?.dueDate ? moment(receipt?.dueDate).format("DD/MM/YYYY HH:mm"):"",
            style: { minWidth: 220, maxWidth: 300 },
            filter: true,
            filterType: "DATE",
            filterConfig: {
                like: false
            },
            persisted: true,
            formattedExportValue: true,
            preventExcelFormat: true,
            sortable: true,

        },
        {
            header: t(["invoice.transactionId"]),
            filter: true,
            style: { minWidth: 200, maxWidth: 300 },
            field: "transactionId",
            persisted: true,
            default: true
        },

        {
            header: t(["invoice.currency"]),
            field: "currency",
            default: true,
            persisted: true,
            sortable:true,
            style: { minWidth: "150px", maxWidth: "300px" },
            body: (receipt) => receipt.currency,
            filter: true,
            filterType:"MULTISELECT",
            filterConfig:{
                options: currencyOptions
            }
        },

        {
            header: t(['stat.total']),
            field: "amount",
            style: { minWidth: "180px", maxWidth: "300px" },
            sortable: true,
            persisted: true,
            default: true,
            sortable:true,
        },

        {
            header: "Source",
            filter: true,
            field: "source",
            style: { minWidth: "180px", maxWidth: "300px" },
            persisted: true,
            default: true,
            sortable:true,
        },

        {
            header: t(['home.paymentMethodType']),
            style: { minWidth: "230px", maxWidth: "300px" },
            field: 'paymentMethod',
        },

        {
            field: "recordDate",
            header: t(['invoice.reportedDate']), 
            body: (receipt) =>receipt?.recordDate ? moment(receipt?.recordDate).format("DD/MM/YYYY HH:mm"):"",
            style: { minWidth: 200, maxWidth: 300 },
            filter: true,
            filterType: "DATE",
            filterConfig: {
                like: false
            },
            persisted: true,
            formattedExportValue: true,
            preventExcelFormat: true,
            sortable: true,

        },
        {
            field:"internalPaymentStatus",
            header:t("bkt.paymentStatus"),
            style: { minWidth: 250, maxWidth: 300 },
            body:(payment)=>{
                return translateLabel(payment?.internalPaymentStatus?.engName,payment?.internalPaymentStatus?.albName,i18n)
            }
        }
    ];
};

export default generatePaymentsReceiptColumns;
